import { FloatingFormItem } from '@/components/_common';
import { Alert, Col, Form, Row, Typography } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import TextArea from 'antd/lib/input/TextArea';

interface Props {
  form: FormInstance<{ description: string }>;
}

export default function CceForm({ form }: Props) {
  return (
    <Form form={form} layout="vertical" preserve={false}>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Alert
            style={{ marginBottom: 24 }}
            type="warning"
            description={
              <Col span={24}>
                <Typography.Title level={5}>
                  Condições de uso da carta de correção:
                </Typography.Title>

                <div style={{ marginBottom: 16 }}>
                  A carta de correção é discliplinada pelo §1º-A ao art. 7º do
                  Convênio S/N, de 15 de dezembro de 1970 e pode ser utilizada
                  regularização de erro ocorrida na emissão de uma nota fiscal,
                  desde que o erro não esteja relacionado com:
                </div>
                <div>
                  I - as variáveis que determinam o valor do imposto tais como:
                  base de cálculo, alíquota, diferença de preço,
                  quantidade,valor da operação ou da prestacão;
                </div>
                <div>
                  II - a correção de dados cadastrais que implique mudanças do
                  remetente ou destinatário;
                </div>
                <div>III - a data de emissão ou de saída;</div>
              </Col>
            }
          />
        </Col>

        <Col xs={24}>
          <FloatingFormItem
            name="description"
            label={'Correção'}
            rules={[
              {
                min: 15,
                message: 'Tamanho mínimo: 15',
              },
            ]}
          >
            <TextArea maxLength={1000} rows={6} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}
